module.exports = __webpack_public_path__ + "img/green-hairy-grass-00.d87ab3ee.png";